import {
  CircularProgress,
} from "@mui/material";
import { useState, useEffect } from "react";
import { fetchCoverage, fetchCoverageMenu } from "../api/api";
import { FiCheckCircle, FiXCircle } from 'react-icons/fi';
import { Link } from "react-router-dom";
import { ColumnsType } from 'antd/es/table';
import { Table, Select } from 'antd';
import { AllStates } from '../common/cities'
interface Utility {
  utility_name?: string;
  available?: boolean;
  utility_id?: string;
  state?: string;
  state_id?: string;
}
interface DataItem {
  state_arr: string[];
  utility_name: string;
  utility_code: string;
}

interface ResponseData {
  provider_list: DataItem[];
  utility_list: DataItem[];
}

interface CategorizedData {
  [state: string]: DataItem[];
}

interface ProcessedData {
  providerStates: string[];
  utilityStates: string[];
  categorizedProviders: CategorizedData;
  categorizedUtilities: CategorizedData;
}

const ServiceAreas = () => {
  const [data, setData] = useState<Utility[]>([]);
  const [filteredData, setFilteredData] = useState<Utility[]>([]);
  const [filteredDataMenu, setFilteredDataMenu] = useState<Utility[]>([]);

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(null);
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc' | 'none'>('asc');
  const [selectState, setSelectState] = useState('all');
  const [filteredStates, setFilteredStates] = useState<any>([]);
  const [type, setType] = useState('utility');
  const [providerStates, setProviderStates] = useState<any>([]);
  const [utilityStates, setUtilityStates] = useState<any>([]);
  const [categorizedProviders, setCategorizedProviders] = useState<any>([]);
  const [categorizedUtilities, setCategorizedUtilities] = useState<any>([]);

  const processLists = (response: ResponseData): ProcessedData => {
    const { provider_list, utility_list } = response;

    const extractStates = (list: DataItem[]): string[] => {
      return Array.from(new Set(list.flatMap((item) => item.state_arr)));
    };

    const providerStates = extractStates(provider_list);
    const utilityStates = extractStates(utility_list);

    const categorizeByState = (list: DataItem[], states: string[]): CategorizedData => {
      const categorized: CategorizedData = {};
      states.forEach((state) => {
        categorized[state] = list
          .filter((item) => item.state_arr.includes(state))
          .map((item) => ({
            ...item,
            state_arr: [state],
          }));
      });
      categorized.all = list;
      return categorized;
    };

    const categorizedProviders = categorizeByState(provider_list, providerStates);
    const categorizedUtilities = categorizeByState(utility_list, utilityStates);

    return {
      providerStates,
      utilityStates,
      categorizedProviders,
      categorizedUtilities,
    };
  };
  const handleSort = () => {
    let newOrder: 'asc' | 'desc' | 'none';
    if (sortOrder === 'none') {
      newOrder = 'asc';
    } else if (sortOrder === 'asc') {
      newOrder = 'desc';
    } else {
      newOrder = 'asc';
    }
    setSortOrder(newOrder);

    const sortedData = [...data].sort((a, b) => {
      if (newOrder === 'asc') {
        return a.state?.localeCompare(b.state || '') || 0;
      } else {
        return b.state?.localeCompare(a.state || '') || 0;
      }
    });
    setData(sortedData);
  };

  function generateUtilityData(data: any, allData: any) {
    const result: any[] = [];

    // Iterate over the provided data and check for state_arr and utility_code match
    data.forEach((utility: any) => {
      // Iterate through each state in the state_arr
      utility.state_arr.forEach((stateCode: any) => {
        // Filter the allData to find matching utility based on state_id and utility_code
        const matchedUtilities = allData.filter(
          (item: any) => item.utility_code === utility.utility_code && item.state_id === stateCode
        );

        matchedUtilities.forEach((utilityData: any) => {
          // Only push if the state_id is not already in the result to avoid duplicates
          if (!result.some((item: any) => item.state_id === stateCode && item.utility_code === utility.utility_code)) {
            result.push({
              ...utilityData, // Merge the full utility data
              state_id: stateCode, // Override state_id with the current state in state_arr
            });
          }
        });
      });
    });

    return result;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        setLoading(true);

        const [menuResponse, coverageResponse] = await Promise.all([fetchCoverageMenu(), fetchCoverage()]);

        if (menuResponse?.status === 1 && coverageResponse?.status === 1) {
          const {
            providerStates,
            utilityStates,
            categorizedProviders,
            categorizedUtilities,
          } = processLists(menuResponse.response);
          setProviderStates(providerStates);
          setUtilityStates(utilityStates);
          setCategorizedProviders(categorizedProviders);
          setCategorizedUtilities(categorizedUtilities);

          const utilities = coverageResponse.response;
          setData(utilities);
          let fliterList = generateUtilityData(categorizedUtilities['all'], utilities)
          console.log(fliterList)
          setFilteredData(fliterList)
          setFilteredDataMenu(fliterList)

          const filteredStates = AllStates.filter((state) => utilityStates.includes(state.state_id));
          setFilteredStates(filteredStates);
        } else {
          throw new Error("Failed to fetch data from one or both APIs");
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error processing utility or menu data:", error);
      }
    };

    fetchData();
  }, []);

  const changeType = (type: string) => {
    setType(type)
    if (type === "utility") {
      let fliterList = generateUtilityData(categorizedUtilities['all'], data)
      setFilteredData(fliterList)
      setFilteredDataMenu(fliterList)
      setSelectState('all')
      const filteredStates = AllStates.filter((state) => utilityStates.includes(state.state_id));
      setFilteredStates(filteredStates);
      setSearch(null)
    }
    else {
      let fliterList = generateUtilityData(categorizedProviders['all'], data)
      setFilteredData(fliterList)
      setFilteredDataMenu(fliterList)
      setSelectState('all')
      const filteredStates = AllStates.filter((state) => providerStates.includes(state.state_id));
      setFilteredStates(filteredStates);
      setSearch(null)
    }
  }




  const handleStateChange = (event: any) => {
    setSelectState(event);
    setSearch(null)

    if (type === "utility") {
      let fliterList = generateUtilityData(categorizedUtilities[event], data)
      setFilteredData(fliterList)
      setFilteredDataMenu(fliterList)
    }
    else {
      let fliterList = generateUtilityData(categorizedProviders[event], data)
      setFilteredData(fliterList)
      setFilteredDataMenu(fliterList)
    };
  }

  const handleUtilityChange = (event: any) => {
    if (event) {
      setSearch(event)
      const filtered = data.filter(item => item.utility_id === event);
      setFilteredData(filtered);
    } else {
      handleStateChange(selectState)
    }

  }

  const columns: ColumnsType<any> = [
    {
      title: 'Utility Name',
      dataIndex: 'utility_name',
      width: 250,
    },
    {
      title: 'State',
      dataIndex: 'state_id',
      width: 100,
      align: 'center',
      sorter: (a, b) => a.state_id.localeCompare(b.state_id),
      onHeaderCell: () => ({ onClick: handleSort }),
      render: (state) => <div style={{ minWidth: 100, textAlign: 'center' }}>{state}</div>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: (a, b) => {
        if (a.status === b.status) return 0;
        return a.status === "1" ? -1 : 1;
      },
      align: 'center',
      width: 180,
      minWidth: 150,
      render: (b) => { return <>{b === "1" ? <FiCheckCircle style={{ color: '#4caf50', minWidth: 120, textAlign: 'center' }} size={30} /> : <FiXCircle style={{ color: '#000000', minWidth: 120, textAlign: 'center' }} size={30} />}</> },
    },
    {
      title: 'Validate Two-Factor Authentication',
      dataIndex: 'two-factor_authorization_status',
      align: 'center',
      minWidth: 150,
      width: 180,
      render: (_, utility: any) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'center', minWidth: 120, alignItems: 'center' }}>
            {['74', '64'].includes(utility.utility_id) ? (
              <div style={{ position: 'relative' }}>
                <a
                  href={utility.utility_id === '74' ? '#note1' : '#note2'}
                  style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
                >
                  <FiCheckCircle style={{ color: '#4caf50' }} size={30} />
                  <span
                    style={{
                      position: 'absolute',
                      top: '-10px',
                      right: '-10px',
                      borderRadius: '50%',
                      padding: '2px 5px',
                      fontSize: '12px',
                      color: '#4caf50',
                    }}
                  >
                    {utility.utility_id === '74' ? 1 : 2}
                  </span>
                </a>
              </div>
            ) : (
              <FiXCircle style={{ color: '#000000' }} size={30} />
            )}
          </div>
        )
      }
    },
    {
      title: 'Access MyAccount',
      dataIndex: 'access_myaccount_status',
      align: 'center',
      width: 180,
      minWidth: 150,
      render: (b) => { return <>{b === "1" ? <FiCheckCircle style={{ color: '#4caf50', minWidth: 120, textAlign: 'center' }} size={30} /> : <FiXCircle style={{ color: '#000000', minWidth: 120, textAlign: 'center' }} size={30} />}</> },
    },
    {
      title: 'Fetch Bills',
      dataIndex: 'fetch_bill_status',
      align: 'center',
      render: (b) => { return <>{b === "1" ? <FiCheckCircle style={{ color: '#4caf50', minWidth: 120, textAlign: 'center' }} size={30} /> : <FiXCircle style={{ color: '#000000', minWidth: 120, textAlign: 'center' }} size={30} />}</> },
      width: 180,
      minWidth: 150,
    },
    {
      title: 'Fetch MyAccount Information',
      dataIndex: 'account_information_status',
      align: 'center',
      render: (b) => { return <>{b === "1" ? <FiCheckCircle style={{ color: '#4caf50', minWidth: 120, textAlign: 'center' }} size={30} /> : <FiXCircle style={{ color: '#000000', minWidth: 120, textAlign: 'center' }} size={30} />}</> },
      width: 180,
      minWidth: 150,
    },
    {
      title: 'Fetch Payment History',
      dataIndex: 'payment_history_status',
      align: 'center',
      render: (b) => { return <>{b === "1" ? <FiCheckCircle style={{ color: '#4caf50', minWidth: 120, textAlign: 'center' }} size={30} /> : <FiXCircle style={{ color: '#000000', minWidth: 120, textAlign: 'center' }} size={30} />}</> },
      width: 180,
      minWidth: 150,
    },
  ];
  const columnsTexus: ColumnsType<any> = [
    {
      title: 'Provider',
      dataIndex: 'utility_name',
      width: 250,
    },
    {
      title: 'State',
      dataIndex: 'state_id',
      width: 100,
      align: 'center',
      sorter: (a, b) => a.state_id.localeCompare(b.state_id),
      onHeaderCell: () => ({ onClick: handleSort }),
      render: (state) => <div style={{ minWidth: 100, textAlign: 'center' }}>{state}</div>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: (a, b) => {
        if (a.status === b.status) return 0;
        return a.status === "1" ? -1 : 1;
      },
      align: 'center',
      width: 180,
      minWidth: 150,
      render: (b) => { return <>{b === "1" ? <FiCheckCircle style={{ color: '#4caf50', minWidth: 120, textAlign: 'center' }} size={30} /> : <FiXCircle style={{ color: '#000000', minWidth: 120, textAlign: 'center' }} size={30} />}</> },
    },
    {
      title: 'Validate Two-Factor Authentication',
      dataIndex: 'two-factor_authorization_status',
      align: 'center',
      minWidth: 150,
      width: 180,
      render: (_, utility: any) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'center', minWidth: 120, alignItems: 'center' }}>
            {['74', '64'].includes(utility.utility_id) ? (
              <div style={{ position: 'relative' }}>
                <a
                  href={utility.utility_id === '74' ? '#note1' : '#note2'}
                  style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
                >
                  <FiCheckCircle style={{ color: '#4caf50' }} size={30} />
                  <span
                    style={{
                      position: 'absolute',
                      top: '-10px',
                      right: '-10px',
                      borderRadius: '50%',
                      padding: '2px 5px',
                      fontSize: '12px',
                      color: '#4caf50',
                    }}
                  >
                    {utility.utility_id === '74' ? 1 : 2}
                  </span>
                </a>
              </div>
            ) : (
              <FiXCircle style={{ color: '#000000' }} size={30} />
            )}
          </div>
        )
      }
    },
    {
      title: 'Access MyAccount',
      dataIndex: 'access_myaccount_status',
      align: 'center',
      width: 180,
      minWidth: 150,
      render: (b) => { return <>{b === "1" ? <FiCheckCircle style={{ color: '#4caf50', minWidth: 120, textAlign: 'center' }} size={30} /> : <FiXCircle style={{ color: '#000000', minWidth: 120, textAlign: 'center' }} size={30} />}</> },
    },
    {
      title: 'Fetch Bills',
      dataIndex: 'fetch_bill_status',
      align: 'center',
      render: (b) => { return <>{b === "1" ? <FiCheckCircle style={{ color: '#4caf50', minWidth: 120, textAlign: 'center' }} size={30} /> : <FiXCircle style={{ color: '#000000', minWidth: 120, textAlign: 'center' }} size={30} />}</> },
      width: 180,
      minWidth: 150,
    },
    {
      title: 'Fetch MyAccount Information',
      dataIndex: 'account_information_status',
      align: 'center',
      render: (b) => { return <>{b === "1" ? <FiCheckCircle style={{ color: '#4caf50', minWidth: 120, textAlign: 'center' }} size={30} /> : <FiXCircle style={{ color: '#000000', minWidth: 120, textAlign: 'center' }} size={30} />}</> },
      width: 180,
      minWidth: 150,
    },
    {
      title: 'Fetch Payment History',
      dataIndex: 'payment_history_status',
      align: 'center',
      render: (b) => { return <>{b === "1" ? <FiCheckCircle style={{ color: '#4caf50', minWidth: 120, textAlign: 'center' }} size={30} /> : <FiXCircle style={{ color: '#000000', minWidth: 120, textAlign: 'center' }} size={30} />}</> },
      width: 180,
      minWidth: 150,
    },
  ];

  return (
    <div style={{ minHeight: 'calc(100vh - 340px)' }} className="container max-w-7xl mx-auto px-4 md:px-8">
      <div className="text-center">
        <h2 className="font-bold text-2xl">Utility Connect Coverage Supports</h2>
        <p className="mt-6 mb-4">
          <span>UtilityConnect currently supports a wide range of utilities listed below. If your client’s utility isn’t included, please provide a test account</span><br />
          <span > We’ll integrate the data within <span className="text-blue-500"> 1-3 Work days </span> after receiving the account. Don’t see your customer’s utility? {' '}
            <Link to="/contact" className="text-blue-500 hover:text-blue-700 underline">
              Click here
            </Link>.</span>
        </p>
      </div>
      <div>
        {loading ? (
          <div className="h-[300px] flex justify-center items-center">
            <CircularProgress />
          </div>
        ) : (
          <><div className="flex flex-col md:flex-row md:items-center md:space-x-4 mb-4">
            <span className="mr-2">Filter:</span>
            <div className="flex items-center md:mb-0 mb-4">

              <div className="flex space-x-2 mr-4">
                <div className="border overflow-hidden bg-transparent shadow-md">
                  <button
                    className={`py-1 px-4 font-medium focus:outline-none transition-all ${type === 'utility' ? 'bg-clip-text text-transparent bg-gradient-to-r from-[#1bd0f6] to-[#0da8ea] border-2 border-[#1bd0f6]' : 'text-black border-2 border-transparent'}`}
                    onClick={() => changeType('utility')}
                  >
                    Utility
                  </button>
                </div>

                <div className="border overflow-hidden bg-transparent shadow-md">
                  <button
                    className={`py-1 px-4 font-medium focus:outline-none transition-all ${type === 'texas' ? 'bg-clip-text text-transparent bg-gradient-to-r from-[#1bd0f6] to-[#0da8ea] border-2 border-[#1bd0f6]' : 'text-black border-2 border-transparent'}`}
                    onClick={() => changeType('texas')}
                  >
                    Provider
                  </button>
                </div>
              </div>

              {type === 'utility' && <>
                <span className="mr-2">State:</span>
                <Select
                  value={selectState}
                  onChange={handleStateChange}
                  style={{ backgroundColor: 'transparent', width: 200, maxWidth: 300 }}
                  className="custom-select"
                  showSearch
                  filterOption={(input, option: any) =>
                    option?.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  <Select.Option key="ALL" value="all">
                    All States
                  </Select.Option>
                  {filteredStates.map((state: any) => (
                    <Select.Option key={state.state_id} value={state.state_id}>
                      {state.state_name}
                    </Select.Option>
                  ))}
                </Select>
              </>}
            </div>

            {type === 'utility' && <div className="flex items-center md:mb-0 mb-4">
              <span className="mr-2">{"Utility Name"}:</span>
              <Select
                value={search}
                onChange={handleUtilityChange}
                placeholder="Please select..."
                allowClear
                style={{ backgroundColor: 'transparent', width: 200, maxWidth: 300 }}
                className="custom-select"
                showSearch
                filterOption={(input, option: any) =>
                  option?.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {
                  Array.from(
                    new Map(
                      filteredDataMenu.map((state: any) => [state.utility_name, state])
                    ).values()
                  ).map((state: any) => (
                    <Select.Option key={state.utility_id} value={state.utility_id}>
                      {state.utility_name}
                    </Select.Option>
                  ))
                }
              </Select>
            </div>}
          </div>
            <Table
              columns={type === 'utility' ? columns : columnsTexus}
              dataSource={filteredData}
              pagination={{
                defaultPageSize: 15,
                pageSizeOptions: ['10', '15', '20'],
                showSizeChanger: true,
                locale: { items_per_page: 'utilities per page' },
              }}
              scroll={{ x: 'auto' }}  // Enable vertical scrolling with max height
              sticky // Make table header sticky
              locale={{ emptyText: 'No utilities found.' }}
            />
          </>
        )}
      </div>
      <div>
        <p className="mt-8">Note:</p>
        <p className="mt-4" id='note1'>1.This indicates that UtilityConnect can automatically disable two-factor authentication (2FA). Specifically, for utility accounts that are the same as BGE, after authorized login, users can proceed with the disabling process for PECO, COMED, PEPCO, DP&L, and ACE.</p>
        <p className="mt-4" id='note2'>2. This indicates that although PSEG cannot disable 2FA, users can simply obtain the account login verification code, and UtilityConnect can assist them in directly verifying their login.</p>
      </div>

    </div>
  );
};

export default ServiceAreas;
